import React from "react";
import "assets/scss/partials/poll.scss";
import audioplaceholder from "assets/img/audioplaceholder.png";
import VideoThumbnail from "react-video-thumbnail";
import LazyLoadImage from "components/LazyLoadImage";

const MediaDisplay = ({ src, alt, mediaStyle, mediaType }) => {
  const containerStyle = {
    background: mediaType !== 3 ? "white" : "orange",
  };

  return (
    <span className="pollListAvatar" style={containerStyle}>
      {mediaType === 4 && <img src={audioplaceholder} alt="pollImage" />}
      {mediaType !== 3 && (
        <>
          <LazyLoadImage
            image={src}
            key={alt}
            alt={alt}
            style={mediaStyle}
            imageClassName={"pollImage"}
            imageWrapperClassName={"pollImage"}
          />
        </>
      )}
      {mediaType === 3 && (
        <VideoThumbnail
          videoUrl={src}
          thumbnailHandler={(thumbnail) => (
            <img src={thumbnail} alt="pollImage" />
          )}
          width={70}
          height={70}
        />
      )}
    </span>
  );
};

export default MediaDisplay;
